module.exports = __webpack_public_path__ + "static/media/Image.8ab59ef3.svg";